import { render, staticRenderFns } from "./ArtistImage.vue?vue&type=template&id=2a2a7e2c&scoped=true"
import script from "./ArtistImage.vue?vue&type=script&lang=ts"
export * from "./ArtistImage.vue?vue&type=script&lang=ts"
import style0 from "./ArtistImage.vue?vue&type=style&index=0&id=2a2a7e2c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a7e2c",
  null
  
)

export default component.exports